(function () {
  'use strict';

  function stateKey() { return window.JPIdentity ? window.JPIdentity.stateKey() : ''; }
  var STUDIO_URL = (window.jpRoutes && window.jpRoutes.customizer) || '/products/custom-temporary-tattoos';
  var PHOTO_URL = (window.jpRoutes && window.jpRoutes.customPhoto) || '/pages/custom-photo-temporary-tattoos';
  var TEXT_URL = (window.jpRoutes && window.jpRoutes.customText) || '/pages/custom-text-temporary-tattoos';

  function routeUrl(base, params) {
    if (window.JPRuntime && window.JPRuntime.route) return window.JPRuntime.route(base, params);
    var query = new URLSearchParams(params || {});
    return base + (query.toString() ? (base.indexOf('?') > -1 ? '&' : '?') + query.toString() : '');
  }

  function studioUrl(params) { return routeUrl(STUDIO_URL, params); }
  function photoUrl(params) { return routeUrl(PHOTO_URL, params); }
  function textUrl(params) { return routeUrl(TEXT_URL, params); }

  function currentReturnUrl() {
    return window.location.pathname + window.location.search + window.location.hash;
  }

  function isPhotoEntry(node) {
    return Boolean(node && node.closest && node.closest('[data-jp-photo-state-root]'));
  }

  function readState() {
    if (window.JPState) return window.JPState.read();
    var state = {};
    var key = stateKey();
    if (key) try { state = JSON.parse(localStorage.getItem(key) || '{}') || {}; }
    catch (error) { if (window.JPRuntime) window.JPRuntime.reportError(error, 'entry-state-read'); }
    return Object.assign({ items: [], plan: 'starter', preferences: [], currentItemId: null, pendingSize: { label: '2 × 3 IN', sizeId: 'portrait-2x3', spaces: 3, orientation: 'portrait' }, orientation: 'portrait', saved: [] }, state);
  }

  function randomCode(prefix) {
    var alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var output = prefix + '-';
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint8Array(8);
      window.crypto.getRandomValues(values);
      values.forEach(function (value) { output += alphabet[value % alphabet.length]; });
      return output;
    }
    for (var index = 0; index < 8; index += 1) output += alphabet[Math.floor(Math.random() * alphabet.length)];
    return output;
  }

  function xmlEscape(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&apos;' }[character];
    });
  }

  function normalizeText(value) {
    var normalized = String(value || '')
      .replace(/\r/g, '')
      .replace(/[\t ]+\n/g, '\n')
      .replace(/\n{4,}/g, '\n\n\n')
      .trim()
      .slice(0, 64);
    return normalized || 'STAY\nWILD';
  }

  function textPreview(value, family, weight) {
    var lines = normalizeText(value).split(/\n/).slice(0, 3);
    var lineHeight = 82;
    var firstY = 380 - ((lines.length - 1) * lineHeight / 2);
    var tspans = lines.map(function (line, index) {
      return '<tspan x="300" y="' + (firstY + (index * lineHeight)) + '">' + xmlEscape(line) + '</tspan>';
    }).join('');
    var safeFamily = xmlEscape(family || 'JP Reckless, Georgia, serif');
    var safeWeight = /^\d{3}$/.test(String(weight || '')) ? String(weight) : '400';
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="600" height="760" viewBox="0 0 600 760">' +
      '<rect width="600" height="760" fill="white"/><text text-anchor="middle" font-family="' + safeFamily + '" font-size="72" font-weight="' + safeWeight + '" fill="#111">' +
      tspans + '</text></svg>'
    );
  }

  function openStudio(item, mode) {
    var editor = document.querySelector('[data-jp-studio-editor]');
    var photoRoot = document.querySelector('[data-jp-photo-state-root]');
    var textRoot = document.querySelector('[data-jp-text-state-root]');
    var returnTo = window.location.pathname + window.location.search;

    /* Editors live only on their dedicated tool pages. Studio / Current Set
       never embeds the Canvas. The tool page may switch A -> B in place. */
    if (mode === 'image') {
      if (photoRoot && editor) {
        document.dispatchEvent(new CustomEvent('justpress:task-transition', { detail: { from: 'entry', to: 'editor', mode: mode, itemId: item.id } }));
        document.dispatchEvent(new CustomEvent('justpress:open-studio', { detail: { mode: mode, item: item.id } }));
        return;
      }
      window.location.assign(photoUrl({ mode: 'image', item: item.id, return_to: returnTo }));
      return;
    }

    if (mode === 'text') {
      if (textRoot && editor) {
        document.dispatchEvent(new CustomEvent('justpress:task-transition', { detail: { from: 'entry', to: 'editor', mode: mode, itemId: item.id } }));
        document.dispatchEvent(new CustomEvent('justpress:open-studio', { detail: { mode: mode, item: item.id } }));
        return;
      }
      window.location.assign(textUrl({ mode: 'text', item: item.id, return_to: returnTo }));
    }
  }

  function saveItem(item, mode) {
    var state = readState();
    var saved = false;
    if (window.JPState && typeof window.JPState.update === 'function') {
      saved = window.JPState.update(function (next) {
        next.items = (next.items || []).filter(function (entry) { return String(entry.id) !== String(item.id); });
        next.items.push(item);
        next.currentItemId = item.id;
        return next;
      }, 'entry-save');
      state = readState();
    } else {
      state.items = state.items.filter(function (entry) { return String(entry.id) !== String(item.id); });
      state.items.push(item);
      state.currentItemId = item.id;
      var key = stateKey();
      if (key) try { localStorage.setItem(key, JSON.stringify(state)); saved = true; }
      catch (error) { if (window.JPRuntime) window.JPRuntime.reportError(error, 'entry-state-write'); }
    }
    if (!saved) {
      if (window.JPRuntime) window.JPRuntime.toast('This design could not be stored safely. Secure the upload and try again.');
      return false;
    }
    document.dispatchEvent(new CustomEvent('justpress:set-change', { detail: state }));
    openStudio(item, mode);
    return true;
  }

  function setStatus(scope, message, state) {
    if (!scope) return;
    var status = scope.querySelector('[data-jp-entry-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-jp-entry-status', '');
      status.setAttribute('role', 'status');
      status.className = 'jp-entry-status';
      var actions = scope.querySelector('.jp-start-path__actions,.jp-custom-entry__actions,.jp-studio-entry__choices');
      if (actions) actions.insertAdjacentElement('afterend', status);
      else scope.appendChild(status);
    }
    status.dataset.state = state || 'neutral';
    status.textContent = message || '';
  }

  function previewRoot(node, scope) {
    var direct = node && node.closest ? node.closest('[data-jp-text-preview]') : null;
    if (direct) return direct;
    return scope && scope.querySelector ? scope.querySelector('[data-jp-text-preview]') : null;
  }

  function selectedFont(scope) {
    var option = scope && scope.querySelector('[data-jp-text-font-option].is-selected,[data-jp-text-font-option][aria-pressed="true"],[data-jp-text-font-option][aria-checked="true"]');
    return {
      id: option && option.dataset.fontId || 'reckless',
      name: option && option.dataset.fontName || 'Reckless Serif',
      family: option && option.dataset.fontFamily || 'JP Reckless, Georgia, serif',
      category: option && option.dataset.fontCategory || 'serif',
      weight: option && option.dataset.fontWeight || '400'
    };
  }

  function textConfig(node, scope) {
    var preview = previewRoot(node, scope);
    var input = preview && preview.querySelector('[data-jp-text-preview-input]');
    return {
      value: normalizeText(input ? input.value : 'STAY\nWILD'),
      font: selectedFont(preview)
    };
  }

  function createTextDraft(config) {
    var id = 'text-' + Date.now().toString(36);
    var image = textPreview(config.value, config.font.family, config.font.weight);
    return {
      id: id,
      designCode: randomCode('TXT'),
      title: 'Custom text',
      image: image,
      previewImage: image,
      style: 'Custom text',
      description: '',
      sourceType: 'text',
      type: 'text',
      editorStatus: 'draft',
      textValue: config.value,
      fontId: config.font.id,
      fontFamily: config.font.family,
      fontCategory: config.font.category,
      fontWeight: config.font.weight,
      fontSize: 72,
      lineHeight: 0.95,
      letterSpacing: 0,
      textAlign: 'center',
      editState: { x: 0, y: 0, zoom: 1, rotation: 0, fit: 'contain', erased: false, canvasWidth: 0, canvasHeight: 0 },
      sizeId: 'portrait-2x3',
      sizeLabel: '2 × 3 IN',
      spaces: 3,
      orientation: 'portrait'
    };
  }

  function updateTextPreview(preview) {
    if (!preview) return;
    var input = preview.querySelector('[data-jp-text-preview-input]');
    var raw = input ? String(input.value || '').replace(/\r/g, '').slice(0, 64) : '';
    var display = raw || 'YOUR TEXT';
    preview.querySelectorAll('[data-jp-text-preview-value]').forEach(function (node) {
      node.textContent = display;
    });
    var counter = preview.querySelector('[data-jp-text-character-count]');
    if (counter) counter.textContent = String(raw.length);
  }

  function selectFont(option) {
    var preview = option && option.closest('[data-jp-text-preview]');
    if (!preview) return;
    preview.querySelectorAll('[data-jp-text-font-option]').forEach(function (node) {
      var selected = node === option;
      node.classList.toggle('is-selected', selected);
      node.setAttribute('aria-checked', selected ? 'true' : 'false');
      node.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  var UNREADABLE_IMAGE_MESSAGE = 'This file isn’t a readable JPG or PNG. Try another image.';
  var IMAGE_FORMAT_MESSAGE = 'Choose a JPG or PNG under 20 MB. iPhone HEIC photos: set Camera → Formats → Most Compatible, or export as JPG.';

  function decodeWithImageElement(file) {
    return new Promise(function (resolve) {
      var url = '';
      try { url = URL.createObjectURL(file); } catch (_) { resolve(false); return; }
      var probe = new Image();
      function finish(ok) {
        probe.onload = null;
        probe.onerror = null;
        try { URL.revokeObjectURL(url); } catch (_) { /* already released */ }
        resolve(ok);
      }
      probe.onload = function () { finish(probe.naturalWidth > 0 && probe.naturalHeight > 0); };
      probe.onerror = function () { finish(false); };
      probe.src = url;
    });
  }

  function verifyReadableImage(file, timeoutMs) {
    /* Decode the file before it enters the Set so corrupt or mislabeled files
       never become items. Resolves true/false and never rejects. */
    var attempt = typeof window.createImageBitmap === 'function'
      ? window.createImageBitmap(file).then(function (bitmap) {
        var ok = Boolean(bitmap && bitmap.width > 0 && bitmap.height > 0);
        if (bitmap && typeof bitmap.close === 'function') bitmap.close();
        return ok || decodeWithImageElement(file);
      }, function () { return decodeWithImageElement(file); })
      : decodeWithImageElement(file);
    return new Promise(function (resolve) {
      var timer = window.setTimeout(function () { resolve(false); }, Number(timeoutMs) || 8000);
      Promise.resolve(attempt).then(function (ok) {
        window.clearTimeout(timer);
        resolve(Boolean(ok));
      }, function () {
        window.clearTimeout(timer);
        resolve(false);
      });
    });
  }

  function handleUploadFile(file, scope) {
    if (!file) return;
    if (!/^image\/(png|jpeg)$/.test(file.type) || file.size > 20 * 1024 * 1024) {
      setStatus(scope, IMAGE_FORMAT_MESSAGE, 'error');
      return;
    }
    if (!window.JPLocalAssets || !window.JPLocalAssets.put) {
      setStatus(scope, 'Local draft storage is unavailable. Try another browser or disable private browsing.', 'error');
      return;
    }
    setStatus(scope, 'Preparing your artwork…', 'loading');
    var unreadable = {};
    verifyReadableImage(file, 8000).then(function (readable) {
      if (!readable) throw unreadable;
      return window.JPLocalAssets.put(file, { prefix: 'source', kind: 'source', name: file.name });
    }).then(function (localAssetId) {
      var id = 'upload-' + Date.now().toString(36);
      var item = {
        id: id,
        designCode: randomCode('UPL'),
        title: 'Customer Upload',
        originalFilename: file.name,
        image: '',
        previewImage: '',
        sourceUrl: '',
        previewUrl: '',
        renderUrl: '',
        localAssetId: localAssetId,
        localRenderAssetId: null,
        style: 'Customer Upload',
        description: '',
        sourceType: 'upload',
        type: 'image',
        editorStatus: 'draft',
        textValue: null,
        uploadId: null,
        originalUploadId: null,
        uploadStatus: 'pending',
        uploadError: null,
        renderStatus: 'dirty',
        renderError: null,
        sizeId: (window.__jpPhotoPendingSize && window.__jpPhotoPendingSize.sizeId) || 'portrait-3x4',
        sizeLabel: (window.__jpPhotoPendingSize && window.__jpPhotoPendingSize.label) || '3 × 4 IN',
        spaces: Math.max(1, Number(window.__jpPhotoPendingSize && window.__jpPhotoPendingSize.spaces) || 4),
        orientation: (window.__jpPhotoPendingSize && window.__jpPhotoPendingSize.orientation) || 'portrait',
        editState: { x: 0, y: 0, zoom: 1, rotation: 0, fit: 'contain', erased: false, canvasWidth: 0, canvasHeight: 0 }
      };
      setStatus(scope, 'Opening editor. Secure saving will continue in the background…', 'success');
      saveItem(item, 'image');
    }).catch(function (error) {
      if (error === unreadable) { setStatus(scope, UNREADABLE_IMAGE_MESSAGE, 'error'); return; }
      setStatus(scope, String(error && error.message || 'This artwork could not be stored locally. Try another file.'), 'error');
    });
  }

  document.addEventListener('click', function (event) {
    var fontOption = event.target.closest('[data-jp-text-font-option]');
    if (fontOption) {
      event.preventDefault();
      selectFont(fontOption);
      return;
    }

    var sizeGuide = event.target.closest('[data-jp-photo-size-guide]');
    if (sizeGuide) {
      event.preventDefault();
      var sizeRoot = sizeGuide.closest('[data-jp-p0-root]');
      if (sizeRoot) sizeRoot.dispatchEvent(new CustomEvent('justpress:open-size', { bubbles: true, detail: { source: 'photo-landing' } }));
      return;
    }

    var upload = event.target.closest('[data-jp-entry-upload]');
    if (upload) {
      /* File selection belongs only to Custom Photo state A. Everywhere else,
         Upload is navigation into the dedicated Photo tool. This prevents Home
         and Current Set from silently skipping the approved state-A page. */
      if (isPhotoEntry(upload)) {
        var photoScope = upload.closest('[data-jp-photo-state-root]');
        var input = photoScope && photoScope.querySelector('[data-jp-entry-file-input]');
        if (input) {
          event.preventDefault();
          input.click();
        }
        return;
      }
      if (upload.tagName !== 'A') {
        event.preventDefault();
        window.location.assign(photoUrl({ return_to: currentReturnUrl() }));
      }
      return;
    }

    var textEntry = event.target.closest('[data-jp-entry-text]');
    if (!textEntry) return;
    var preview = textEntry.closest('[data-jp-text-preview]');
    var fallbackHref = textEntry.tagName === 'A' ? textEntry.getAttribute('href') : '';
    if (!preview) {
      /* Links keep their real href for progressive navigation. Legacy buttons
         are routed here so CREATE TEXT can never become a dead control. */
      if (textEntry.tagName !== 'A') {
        event.preventDefault();
        window.location.assign(textUrl({ return_to: currentReturnUrl() }));
      }
      return;
    }
    var textScope = textEntry.closest('[data-jp-entry-scope],[data-jp-start-path]') || document;
    event.preventDefault();
    var config = textConfig(textEntry, textScope);
    setStatus(textScope, 'Opening your text in the full canvas…', 'loading');
    if (saveItem(createTextDraft(config), 'text')) return;
    setStatus(textScope, 'Your text could not be stored in this browser.', 'error');
    if (fallbackHref && fallbackHref.charAt(0) !== '#') window.location.assign(fallbackHref);
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-jp-text-preview-input]')) return;
    updateTextPreview(event.target.closest('[data-jp-text-preview]'));
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-jp-entry-file-input]') || !event.target.files || !event.target.files[0]) return;
    var input = event.target;
    var file = input.files[0];
    input.value = '';
    handleUploadFile(file, input.closest('[data-jp-entry-scope],[data-jp-start-path]'));
  });

  document.addEventListener('dragover', function (event) {
    var scope = event.target && event.target.closest ? event.target.closest('[data-jp-photo-state-root]') : null;
    if (!scope || !scope.querySelector('[data-jp-entry-upload]')) return;
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
    scope.classList.add('is-dragging-artwork');
  });

  document.addEventListener('dragleave', function (event) {
    var scope = event.target && event.target.closest ? event.target.closest('[data-jp-photo-state-root]') : null;
    if (!scope) return;
    if (!event.relatedTarget || !scope.contains(event.relatedTarget)) scope.classList.remove('is-dragging-artwork');
  });

  document.addEventListener('drop', function (event) {
    var scope = event.target && event.target.closest ? event.target.closest('[data-jp-photo-state-root]') : null;
    if (!scope || !scope.querySelector('[data-jp-entry-upload]')) return;
    event.preventDefault();
    scope.classList.remove('is-dragging-artwork');
    var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
    handleUploadFile(file, scope);
  });

  document.addEventListener('justpress:pending-size-applied', function (event) {
    if (event.detail && event.detail.size) window.__jpPhotoPendingSize = Object.assign({}, event.detail.size);
  });

  function syncPhotoEntryNavigation() {
    var root = document.querySelector('[data-jp-photo-state-root]');
    if (!root || !document.body) return;
    if (document.body.classList.contains('jp-task-active')) {
      document.body.classList.remove('jp-photo-entry-immersive');
      return;
    }
    var currentSet = root.querySelector('.jp-photo-current-set');
    if (!currentSet) { document.body.classList.remove('jp-photo-entry-immersive'); return; }
    var navHeight = 76;
    var visible = currentSet.getBoundingClientRect().bottom <= (window.innerHeight - navHeight);
    document.body.classList.toggle('jp-photo-entry-immersive', !visible);
  }

  var photoEntryNavScheduled = false;
  function schedulePhotoEntryNavigation() {
    if (photoEntryNavScheduled) return;
    photoEntryNavScheduled = true;
    window.requestAnimationFrame(function () {
      photoEntryNavScheduled = false;
      syncPhotoEntryNavigation();
    });
  }
  window.addEventListener('scroll', schedulePhotoEntryNavigation, { passive: true });
  window.addEventListener('resize', schedulePhotoEntryNavigation, { passive: true });
  document.addEventListener('justpress:task-transition', schedulePhotoEntryNavigation);

  document.querySelectorAll('[data-jp-text-preview]').forEach(updateTextPreview);
  schedulePhotoEntryNavigation();
})();
